<template>
  <v-col>
    <v-row>
      <v-col>
        <vue-tel-input
          v-model="phone"
          :disabled="!enableTextField"
          :preferred-countries="preferredCountries"
          @onInput="validateTel" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="newMember.firstName"
          :disabled="!enableTextField"
          label="First Name" />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="newMember.lastName"
          :disabled="!enableTextField"
          label="Last Name" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="newMember.email"
          :disabled="!enableTextField"
          label="Email" />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="newMember.cardId"
          :disabled="!enableTextField"
          label="Card Id" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="newMember.spending.total"
          class="text-right"
          :disabled="true"
          label="Spending Total" />
      </v-col>
      <v-col cols="6">
        <v-text-field
          :value="newMember.type.toUpperCase()"
          class="text-right"
          :disabled="true"
          label="Member Type" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="newMember.birthDate"
          :disabled="!enableTextField"
          label="DOB"
          type="date" />
      </v-col>
      <v-col cols="6">
        <v-select
          v-model="newMember.gender"
          :disabled="!enableTextField"
          :items="genderItems"
          label="Gender" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="newMember.note"
          :disabled="!enableTextField"
          outlined
          label="Note" />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="isNewMember">
        <v-btn
          outlined
          small
          color="primary"
          :disabled="!telInfo.isValid"
          @click="createMember">
          Save
        </v-btn>
      </v-col>
      <v-col v-else-if="!enableEdit">
        <v-btn
          outlined
          small
          color="primary"
          @click="enableEdit = true">
          Edit
        </v-btn>
      </v-col>
      <v-col v-else>
        <v-btn
          outlined
          small
          :disabled="!telInfo.isValid"
          color="primary"
          @click="editMember">
          Save
        </v-btn>
        <v-btn
          outlined
          small
          color="pink"
          class="ml-4"
          @click="enableEdit = false">
          Cancel
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      required: true
    },
    isNewMember: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      enableEdit: false,
      newMember: this.member,
      phone: this.member.tel,
      telInfo: {
        isValid: true,
        tel: this.member.tel,
        telInfo: this.member.telInfo
      },
      typeItems: ['normal', 'vip'],
      preferredCountries: ['TH', 'SG', 'MY', 'CN'],
      genderItems: ['N/A', 'male', 'female']
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    enableTextField () {
      return this.enableEdit || this.isNewMember
    }
  },
  methods: {
    createMember () {
      this.$emit('onCreateMember', this.newMember)
    },
    validateTel ({ number, isValid, country }) {
      this.telInfo = {
        tel: number.e164,
        isValid,
        telInfo: {
          dialCode: country.dialCode,
          iso2: country.iso2,
          name: country.name
        }
      }
    },
    editMember () {
      this.newMember.tel = this.telInfo.tel
      this.newMember.telInfo = this.telInfo.telInfo
      this.$emit('onUpdateMember', this.newMember)
      this.enableEdit = false
    }
  }
}
</script>
<style scoped>
.fade-in {
  transition:opacity 0.8s
}

</style>
